import { BooleanInput } from "@angular/cdk/coercion";
import { NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
  signal,
  ViewEncapsulation,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Router, RouterLink } from "@angular/router";
import { SafeHtmlPipe } from "@davesa/pipes/safehtml.pipe";
import { DavesaConfigService, Scheme } from "@davesa/services/config";
import { DavesaConfirmationService } from "@davesa/services/confirmation";
import { AuthDavesaV2Service } from "app/core/auth-davesa/auth-davesa-v2.service";
import { User, UserV2 } from "app/core/interfaces/user.interface";
import { Subject } from "rxjs";

@Component({
    selector: "user-menu",
    templateUrl: "./user-menu.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "user",
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        NgClass,
        MatDividerModule,
        RouterLink,
    ],
    providers: [SafeHtmlPipe]
})
export class UserMenuComponent implements OnInit, OnDestroy {
  private _authDavesaService = inject(AuthDavesaV2Service);

  public loginUser = signal<User | UserV2 | null>(null);
  // public imageUrl = signal<string | null>(null);
  public status = signal<string | null>(null);

  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar: boolean = true;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _davesaConfigService: DavesaConfigService,
    private _davesaConfirmationService: DavesaConfirmationService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // // Subscribe to user changes
    this.loginUser.set(this._authDavesaService.loginUser());
    // this.imageUrl.set(this._authDavesaService.loginUser().profile_img_url);
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.loginUser) {
      return;
    }

    // this._usersService.updateUser(this.user).subscribe((res: Update<object>) => {
    //     if (res) {
    //         this._usersService.changeProfileDetails$.next(true);
    //         this._usersService.userSubject$.next(true);
    //         // this._snackbarService.success(res?.message);
    //     }
    //   });

    // Update the user
    // this._usersService
    //     .updateUser({
    //         ...this.user,
    //         status,
    //     })
    //     .subscribe();
  }

  /**
   * Sign out
   */
  async signOut() {
    const signOur = await this._authDavesaService.signOut()
    this.loginUser = null;
    this._router.navigate(["sign-out"]);
  }

  settings() {
    this._router.navigateByUrl("/pages/settings");
  }
  profile() {
    this._router.navigateByUrl("/pages/profile");
  }

  loginHome() {
    this._router.navigate(["/login-home"]);
  }

  /**
   * Set the scheme on the config
   *
   * @param scheme
   */
  setScheme(scheme: Scheme): void {
    this._davesaConfigService.config = { scheme };
  }

  // <div innerHtml='${this._authDavesaSignalService.user()} | safeHtml'></div>

  viewTokenDetails() {
    const config = {
      title: "User Details",
      message: `
                        <div>isLoggedIn: ${this._authDavesaService.isLoggedIn()}</div>
                    `,
      icon: {
        show: true,
        name: "heroicons_outline:davesa-c",
        color: "",
      },
      actions: {
        confirm: {
          show: true,
          label: "Close",
          color: "primary",
        },
        cancel: {
          show: false,
          label: "Cancel",
        },
      },
      dismissible: true,
    };
    this.openConfirmationDialog(config);
  }

  viewUserDetails() {
    const user: any = this._authDavesaService.loginUser();
    const config = {
      title: "User Details",
      message: `
                        <div>'${user.data.oid}'</div>
                        <div>'${user.data.first_name} ${user.data.last_name}'</div>
                        <div>'${user.data.email}'</div>
                    `,
      icon: {
        show: true,
        name: "heroicons_outline:davesa-c",
        color: "",
      },
      actions: {
        confirm: {
          show: true,
          label: "Close",
          color: "primary",
        },
        cancel: {
          show: false,
          label: "Cancel",
        },
      },
      dismissible: true,
    };
    this.openConfirmationDialog(config);
  }

  openConfirmationDialog(config): void {
    // Open the dialog and save the reference of it
    const dialogRef = this._davesaConfirmationService.open(config);

    // Subscribe to afterClosed from the dialog reference
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }
}
